import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {LabelledInfo} from '../molecules';
import SystemTitle from './SystemTitle';
import {SectionTitle} from '../atoms';
import {formatAddOns} from '../utils/formats';
import Loading from '../molecules/Loading';
import ExpandableSystemInfo from './ExpandableSystemInfo';
import {getLocalTime} from '../utils/systems';

const Container = styled.div`
  padding: 32px;
  flex: 0.20;
  background-color: ${props => props.theme.colors.lightGray};
`;

const InfoContainer = styled.div``;

const SystemSideBar = ({system, loading}) => {
  if (loading) {
    return (
      <Container style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <Loading loading={loading} message=""/>
      </Container>
    );
  }
  const {project, location} = system;
  const client = project ? project.client : null;
  return (
    <Container>
      <SectionTitle style={{marginBottom: '8px'}}>System Type</SectionTitle>
      <SystemTitle id={system.id} positionKnown={Boolean(location.longitude && location.latitude)}/>
      <SectionTitle style={{marginTop: '36px'}}>Basic Information</SectionTitle>
      <InfoContainer>
        <LabelledInfo title="Gangway" subtitle={system.gangway} style={{marginTop: '24px'}} />
        <LabelledInfo title="Hpu" subtitle={system.hpu} style={{marginTop: '24px'}} />
        <LabelledInfo title="Add-ons" subtitle={formatAddOns(system.addOns || [])} style={{marginTop: '24px'}} />
        <LabelledInfo title="Local Time" subtitle={getLocalTime(system)} style={{marginTop: '24px'}} />
        <ExpandableSystemInfo system={system}/>
      </InfoContainer>
      <SectionTitle style={{marginTop: '36px'}}>Project Information</SectionTitle>
      <InfoContainer>
        {project
          ? (
            <>
              <LabelledInfo title="Project Code" subtitle={project.code} style={{marginTop: '24px'}} />
              <LabelledInfo title="Project Owner" subtitle={project.owner ? project.owner.name : '-'} style={{marginTop: '24px'}} />
              {/* <LabelledInfo title="Location" subtitle={system.location.area} style={{marginTop: '24px'}} /> */}
              <LabelledInfo title="Vessel" subtitle={project.vessel} style={{marginTop: '24px'}} />
            </>
          )
          : (
            <div style={{marginTop: '8px'}}>-</div>
          )
        }
      </InfoContainer>
      <SectionTitle style={{marginTop: '36px'}}>Client Information</SectionTitle>
      <InfoContainer>
        {client
          ? (
            <>
              <LabelledInfo title="Client" subtitle={client.company} style={{marginTop: '24px'}} />
              <LabelledInfo title="Client contact number" subtitle={client.phone || '-'} style={{marginTop: '24px'}} />
            </>
          )
          : (
            <div style={{marginTop: '8px'}}>-</div>
          )
        }
      </InfoContainer>
    </Container>
  );
};

SystemSideBar.propTypes = {
  system: PropTypes.object,
  loading: PropTypes.bool,
};

export default SystemSideBar;

